module.exports = __webpack_public_path__ + "img/phone.a22f13cb.svg";